const permissionInitialState = {
  moduleCode: null,
  readOnly: undefined
};

function ModulePermissionReducer(state = permissionInitialState, action) {
  const { type, payload } = action;

  switch (type) {
    case "MODULE_PERMISSION_INIT":
      return {
        ...state,
        moduleCode: null,
        readOnly: undefined
      };
    case "MODULE_PERMISSION_SUCCESS":
      return {
        ...state,
        moduleCode: payload.moduleCode,
        readOnly: payload.readOnly
      };
    default:
      return state;
  }
}

export default ModulePermissionReducer;
